module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-protect-c328a29f136266be5f2a3aea439b2741.svg";